module.exports = __webpack_public_path__ + "img/guanyu_yous3@2x.194f82bb.png";